module.exports = __webpack_public_path__ + "static/media/drop-down.bd87519f.svg";